import apiFetch from '../apiFetch'

export default function (idTipoDiluyente) {
  return apiFetch({endPoint: `TipoDiluyente/obtenerTipoDiluyente?idTipoDiluyente=` + idTipoDiluyente, method: 'GET', body: null})
}